import {EventPost, Event} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const eventsPost = (data: EventPost, draft: boolean) => baseRequestService<Event>({
    url: '/events',
    method: 'POST',
    data,
    params: { draft }
})